/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignPlayersRequest,
  AttendanceMarkRequest,
  BulkAttendanceRequest,
  Training,
  TrainingAttendance,
  TrainingCreateRequest,
  TrainingNote,
  TrainingNoteCreateRequest,
  TrainingPlayer,
  TrainingPlayerClaim,
  TrainingPlayerSettingsRequest,
  TrainingRecurringPayment,
  TrainingRecurringPaymentUpsertRequest,
  TrainingSession,
  TrainingSessionCreateRequest,
  TrainingSessionUpdateRequest,
  TrainingUpdateRequest,
} from '../models/index';
import {
    AssignPlayersRequestFromJSON,
    AssignPlayersRequestToJSON,
    AttendanceMarkRequestFromJSON,
    AttendanceMarkRequestToJSON,
    BulkAttendanceRequestFromJSON,
    BulkAttendanceRequestToJSON,
    TrainingFromJSON,
    TrainingToJSON,
    TrainingAttendanceFromJSON,
    TrainingAttendanceToJSON,
    TrainingCreateRequestFromJSON,
    TrainingCreateRequestToJSON,
    TrainingNoteFromJSON,
    TrainingNoteToJSON,
    TrainingNoteCreateRequestFromJSON,
    TrainingNoteCreateRequestToJSON,
    TrainingPlayerFromJSON,
    TrainingPlayerToJSON,
    TrainingPlayerClaimFromJSON,
    TrainingPlayerClaimToJSON,
    TrainingPlayerSettingsRequestFromJSON,
    TrainingPlayerSettingsRequestToJSON,
    TrainingRecurringPaymentFromJSON,
    TrainingRecurringPaymentToJSON,
    TrainingRecurringPaymentUpsertRequestFromJSON,
    TrainingRecurringPaymentUpsertRequestToJSON,
    TrainingSessionFromJSON,
    TrainingSessionToJSON,
    TrainingSessionCreateRequestFromJSON,
    TrainingSessionCreateRequestToJSON,
    TrainingSessionUpdateRequestFromJSON,
    TrainingSessionUpdateRequestToJSON,
    TrainingUpdateRequestFromJSON,
    TrainingUpdateRequestToJSON,
} from '../models/index';

export interface AssignPlayersToSessionRequest {
    sessionId: string;
    assignPlayersRequest: AssignPlayersRequest;
}

export interface AssignPlayersToTrainingRequest {
    id: string;
    assignPlayersRequest: AssignPlayersRequest;
}

export interface BulkMarkAttendanceRequest {
    sessionId: string;
    bulkAttendanceRequest: BulkAttendanceRequest;
}

export interface ClaimTrainingPlayerInvitationsRequest {
    email: string;
}

export interface CreateTrainingRequest {
    trainingCreateRequest: TrainingCreateRequest;
}

export interface CreateTrainingNoteRequest {
    id: string;
    trainingNoteCreateRequest: TrainingNoteCreateRequest;
}

export interface CreateTrainingSessionRequest {
    id: string;
    trainingSessionCreateRequest: TrainingSessionCreateRequest;
}

export interface DeleteTrainingRequest {
    id: string;
}

export interface DeleteTrainingNoteRequest {
    id: string;
    noteId: string;
}

export interface DeleteTrainingSessionRequest {
    id: string;
    sessionId: string;
}

export interface GetPendingTrainingPlayerInvitationsRequest {
    email: string;
}

export interface GetPlayerTrainingNotesRequest {
    playerId: string;
    publicOnly?: boolean;
}

export interface GetRecurringTrainingPaymentsRequest {
    id: string;
}

export interface GetSessionAttendanceRequest {
    sessionId: string;
}

export interface GetTrainingByIdRequest {
    id: string;
}

export interface GetTrainingNotesRequest {
    id: string;
    publicOnly?: boolean;
}

export interface GetTrainingPlayersRequest {
    id: string;
}

export interface GetTrainingSessionsRequest {
    id: string;
}

export interface GetUserTrainingsRequest {
    email: string;
}

export interface MarkAttendanceRequest {
    sessionId: string;
    attendanceMarkRequest: AttendanceMarkRequest;
}

export interface RemovePlayerFromTrainingRequest {
    id: string;
    playerId: string;
}

export interface UpdateTrainingRequest {
    id: string;
    trainingUpdateRequest: TrainingUpdateRequest;
}

export interface UpdateTrainingNoteRequest {
    id: string;
    noteId: string;
    trainingNoteCreateRequest: TrainingNoteCreateRequest;
}

export interface UpdateTrainingPlayerSettingsRequest {
    id: string;
    playerId: string;
    trainingPlayerSettingsRequest: TrainingPlayerSettingsRequest;
}

export interface UpdateTrainingSessionRequest {
    id: string;
    sessionId: string;
    trainingSessionUpdateRequest: TrainingSessionUpdateRequest;
}

export interface UpsertRecurringTrainingPaymentRequest {
    id: string;
    trainingRecurringPaymentUpsertRequest: TrainingRecurringPaymentUpsertRequest;
}

/**
 * TrainingApi - interface
 * 
 * @export
 * @interface TrainingApiInterface
 */
export interface TrainingApiInterface {
    /**
     * 
     * @summary Replace session players with the provided selection
     * @param {string} sessionId 
     * @param {AssignPlayersRequest} assignPlayersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    assignPlayersToSessionRaw(requestParameters: AssignPlayersToSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Replace session players with the provided selection
     */
    assignPlayersToSession(requestParameters: AssignPlayersToSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Replace training players with the provided selection
     * @param {string} id 
     * @param {AssignPlayersRequest} assignPlayersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    assignPlayersToTrainingRaw(requestParameters: AssignPlayersToTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Replace training players with the provided selection
     */
    assignPlayersToTraining(requestParameters: AssignPlayersToTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Mark attendance for multiple players in a session
     * @param {string} sessionId 
     * @param {BulkAttendanceRequest} bulkAttendanceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    bulkMarkAttendanceRaw(requestParameters: BulkMarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Mark attendance for multiple players in a session
     */
    bulkMarkAttendance(requestParameters: BulkMarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Claim player profiles invited to the authenticated user\'s email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    claimTrainingPlayerInvitationsRaw(requestParameters: ClaimTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlayerClaim>>>;

    /**
     * Claim player profiles invited to the authenticated user\'s email
     */
    claimTrainingPlayerInvitations(requestParameters: ClaimTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlayerClaim>>;

    /**
     * 
     * @summary Create a training
     * @param {TrainingCreateRequest} trainingCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    createTrainingRaw(requestParameters: CreateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Training>>;

    /**
     * Create a training
     */
    createTraining(requestParameters: CreateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Training>;

    /**
     * 
     * @summary Create a public or private training note
     * @param {string} id 
     * @param {TrainingNoteCreateRequest} trainingNoteCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    createTrainingNoteRaw(requestParameters: CreateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingNote>>;

    /**
     * Create a public or private training note
     */
    createTrainingNote(requestParameters: CreateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingNote>;

    /**
     * 
     * @summary Create a training session
     * @param {string} id 
     * @param {TrainingSessionCreateRequest} trainingSessionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    createTrainingSessionRaw(requestParameters: CreateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingSession>>;

    /**
     * Create a training session
     */
    createTrainingSession(requestParameters: CreateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingSession>;

    /**
     * 
     * @summary Delete a training
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    deleteTrainingRaw(requestParameters: DeleteTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a training
     */
    deleteTraining(requestParameters: DeleteTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a training note
     * @param {string} id 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    deleteTrainingNoteRaw(requestParameters: DeleteTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a training note
     */
    deleteTrainingNote(requestParameters: DeleteTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a training session
     * @param {string} id 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    deleteTrainingSessionRaw(requestParameters: DeleteTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a training session
     */
    deleteTrainingSession(requestParameters: DeleteTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get all trainings for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getAllTrainingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Training>>>;

    /**
     * Get all trainings for the authenticated user
     */
    getAllTrainings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Training>>;

    /**
     * 
     * @summary Get pending training player invitations for the authenticated user\'s email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getPendingTrainingPlayerInvitationsRaw(requestParameters: GetPendingTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlayerClaim>>>;

    /**
     * Get pending training player invitations for the authenticated user\'s email
     */
    getPendingTrainingPlayerInvitations(requestParameters: GetPendingTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlayerClaim>>;

    /**
     * 
     * @summary Get training notes for a player
     * @param {string} playerId 
     * @param {boolean} [publicOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getPlayerTrainingNotesRaw(requestParameters: GetPlayerTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingNote>>>;

    /**
     * Get training notes for a player
     */
    getPlayerTrainingNotes(requestParameters: GetPlayerTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingNote>>;

    /**
     * 
     * @summary Get recurring payment records for a training
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getRecurringTrainingPaymentsRaw(requestParameters: GetRecurringTrainingPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingRecurringPayment>>>;

    /**
     * Get recurring payment records for a training
     */
    getRecurringTrainingPayments(requestParameters: GetRecurringTrainingPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingRecurringPayment>>;

    /**
     * 
     * @summary Get session attendance records
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getSessionAttendanceRaw(requestParameters: GetSessionAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingAttendance>>>;

    /**
     * Get session attendance records
     */
    getSessionAttendance(requestParameters: GetSessionAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingAttendance>>;

    /**
     * 
     * @summary Get a training by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getTrainingByIdRaw(requestParameters: GetTrainingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Training>>;

    /**
     * Get a training by id
     */
    getTrainingById(requestParameters: GetTrainingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Training>;

    /**
     * 
     * @summary Get notes for a training
     * @param {string} id 
     * @param {boolean} [publicOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getTrainingNotesRaw(requestParameters: GetTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingNote>>>;

    /**
     * Get notes for a training
     */
    getTrainingNotes(requestParameters: GetTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingNote>>;

    /**
     * 
     * @summary Get training players
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getTrainingPlayersRaw(requestParameters: GetTrainingPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlayer>>>;

    /**
     * Get training players
     */
    getTrainingPlayers(requestParameters: GetTrainingPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlayer>>;

    /**
     * 
     * @summary Get sessions for a training
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getTrainingSessionsRaw(requestParameters: GetTrainingSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingSession>>>;

    /**
     * Get sessions for a training
     */
    getTrainingSessions(requestParameters: GetTrainingSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingSession>>;

    /**
     * 
     * @summary Get all trainings created by a user
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    getUserTrainingsRaw(requestParameters: GetUserTrainingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Training>>>;

    /**
     * Get all trainings created by a user
     */
    getUserTrainings(requestParameters: GetUserTrainingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Training>>;

    /**
     * 
     * @summary Mark attendance for a player in a session
     * @param {string} sessionId 
     * @param {AttendanceMarkRequest} attendanceMarkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    markAttendanceRaw(requestParameters: MarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingAttendance>>;

    /**
     * Mark attendance for a player in a session
     */
    markAttendance(requestParameters: MarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingAttendance>;

    /**
     * 
     * @summary Remove a player from a training
     * @param {string} id 
     * @param {string} playerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    removePlayerFromTrainingRaw(requestParameters: RemovePlayerFromTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a player from a training
     */
    removePlayerFromTraining(requestParameters: RemovePlayerFromTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update a training
     * @param {string} id 
     * @param {TrainingUpdateRequest} trainingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    updateTrainingRaw(requestParameters: UpdateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Training>>;

    /**
     * Update a training
     */
    updateTraining(requestParameters: UpdateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Training>;

    /**
     * 
     * @summary Update a training note
     * @param {string} id 
     * @param {string} noteId 
     * @param {TrainingNoteCreateRequest} trainingNoteCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    updateTrainingNoteRaw(requestParameters: UpdateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingNote>>;

    /**
     * Update a training note
     */
    updateTrainingNote(requestParameters: UpdateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingNote>;

    /**
     * 
     * @summary Update training-specific player fee and invitation settings
     * @param {string} id 
     * @param {string} playerId 
     * @param {TrainingPlayerSettingsRequest} trainingPlayerSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    updateTrainingPlayerSettingsRaw(requestParameters: UpdateTrainingPlayerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingPlayer>>;

    /**
     * Update training-specific player fee and invitation settings
     */
    updateTrainingPlayerSettings(requestParameters: UpdateTrainingPlayerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingPlayer>;

    /**
     * 
     * @summary Update a training session
     * @param {string} id 
     * @param {string} sessionId 
     * @param {TrainingSessionUpdateRequest} trainingSessionUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    updateTrainingSessionRaw(requestParameters: UpdateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingSession>>;

    /**
     * Update a training session
     */
    updateTrainingSession(requestParameters: UpdateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingSession>;

    /**
     * 
     * @summary Create or update a recurring payment record for a training player and billing period
     * @param {string} id 
     * @param {TrainingRecurringPaymentUpsertRequest} trainingRecurringPaymentUpsertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApiInterface
     */
    upsertRecurringTrainingPaymentRaw(requestParameters: UpsertRecurringTrainingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingRecurringPayment>>;

    /**
     * Create or update a recurring payment record for a training player and billing period
     */
    upsertRecurringTrainingPayment(requestParameters: UpsertRecurringTrainingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingRecurringPayment>;

}

/**
 * 
 */
export class TrainingApi extends runtime.BaseAPI implements TrainingApiInterface {

    /**
     * Replace session players with the provided selection
     */
    async assignPlayersToSessionRaw(requestParameters: AssignPlayersToSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling assignPlayersToSession().'
            );
        }

        if (requestParameters['assignPlayersRequest'] == null) {
            throw new runtime.RequiredError(
                'assignPlayersRequest',
                'Required parameter "assignPlayersRequest" was null or undefined when calling assignPlayersToSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/training-sessions/{sessionId}/players`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignPlayersRequestToJSON(requestParameters['assignPlayersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Replace session players with the provided selection
     */
    async assignPlayersToSession(requestParameters: AssignPlayersToSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignPlayersToSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Replace training players with the provided selection
     */
    async assignPlayersToTrainingRaw(requestParameters: AssignPlayersToTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling assignPlayersToTraining().'
            );
        }

        if (requestParameters['assignPlayersRequest'] == null) {
            throw new runtime.RequiredError(
                'assignPlayersRequest',
                'Required parameter "assignPlayersRequest" was null or undefined when calling assignPlayersToTraining().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/players`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignPlayersRequestToJSON(requestParameters['assignPlayersRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Replace training players with the provided selection
     */
    async assignPlayersToTraining(requestParameters: AssignPlayersToTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignPlayersToTrainingRaw(requestParameters, initOverrides);
    }

    /**
     * Mark attendance for multiple players in a session
     */
    async bulkMarkAttendanceRaw(requestParameters: BulkMarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling bulkMarkAttendance().'
            );
        }

        if (requestParameters['bulkAttendanceRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkAttendanceRequest',
                'Required parameter "bulkAttendanceRequest" was null or undefined when calling bulkMarkAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/training-sessions/{sessionId}/attendance/bulk`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkAttendanceRequestToJSON(requestParameters['bulkAttendanceRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark attendance for multiple players in a session
     */
    async bulkMarkAttendance(requestParameters: BulkMarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkMarkAttendanceRaw(requestParameters, initOverrides);
    }

    /**
     * Claim player profiles invited to the authenticated user\'s email
     */
    async claimTrainingPlayerInvitationsRaw(requestParameters: ClaimTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlayerClaim>>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling claimTrainingPlayerInvitations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{email}/training-player-claims`;
        urlPath = urlPath.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingPlayerClaimFromJSON));
    }

    /**
     * Claim player profiles invited to the authenticated user\'s email
     */
    async claimTrainingPlayerInvitations(requestParameters: ClaimTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlayerClaim>> {
        const response = await this.claimTrainingPlayerInvitationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a training
     */
    async createTrainingRaw(requestParameters: CreateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Training>> {
        if (requestParameters['trainingCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingCreateRequest',
                'Required parameter "trainingCreateRequest" was null or undefined when calling createTraining().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingCreateRequestToJSON(requestParameters['trainingCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingFromJSON(jsonValue));
    }

    /**
     * Create a training
     */
    async createTraining(requestParameters: CreateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Training> {
        const response = await this.createTrainingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a public or private training note
     */
    async createTrainingNoteRaw(requestParameters: CreateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingNote>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTrainingNote().'
            );
        }

        if (requestParameters['trainingNoteCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingNoteCreateRequest',
                'Required parameter "trainingNoteCreateRequest" was null or undefined when calling createTrainingNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/notes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingNoteCreateRequestToJSON(requestParameters['trainingNoteCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingNoteFromJSON(jsonValue));
    }

    /**
     * Create a public or private training note
     */
    async createTrainingNote(requestParameters: CreateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingNote> {
        const response = await this.createTrainingNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a training session
     */
    async createTrainingSessionRaw(requestParameters: CreateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingSession>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTrainingSession().'
            );
        }

        if (requestParameters['trainingSessionCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingSessionCreateRequest',
                'Required parameter "trainingSessionCreateRequest" was null or undefined when calling createTrainingSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/sessions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingSessionCreateRequestToJSON(requestParameters['trainingSessionCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingSessionFromJSON(jsonValue));
    }

    /**
     * Create a training session
     */
    async createTrainingSession(requestParameters: CreateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingSession> {
        const response = await this.createTrainingSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a training
     */
    async deleteTrainingRaw(requestParameters: DeleteTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTraining().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a training
     */
    async deleteTraining(requestParameters: DeleteTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTrainingRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a training note
     */
    async deleteTrainingNoteRaw(requestParameters: DeleteTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTrainingNote().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling deleteTrainingNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/notes/{noteId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a training note
     */
    async deleteTrainingNote(requestParameters: DeleteTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTrainingNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a training session
     */
    async deleteTrainingSessionRaw(requestParameters: DeleteTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTrainingSession().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling deleteTrainingSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/sessions/{sessionId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a training session
     */
    async deleteTrainingSession(requestParameters: DeleteTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTrainingSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Get all trainings for the authenticated user
     */
    async getAllTrainingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Training>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingFromJSON));
    }

    /**
     * Get all trainings for the authenticated user
     */
    async getAllTrainings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Training>> {
        const response = await this.getAllTrainingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get pending training player invitations for the authenticated user\'s email
     */
    async getPendingTrainingPlayerInvitationsRaw(requestParameters: GetPendingTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlayerClaim>>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getPendingTrainingPlayerInvitations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{email}/training-player-invitations`;
        urlPath = urlPath.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingPlayerClaimFromJSON));
    }

    /**
     * Get pending training player invitations for the authenticated user\'s email
     */
    async getPendingTrainingPlayerInvitations(requestParameters: GetPendingTrainingPlayerInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlayerClaim>> {
        const response = await this.getPendingTrainingPlayerInvitationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get training notes for a player
     */
    async getPlayerTrainingNotesRaw(requestParameters: GetPlayerTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingNote>>> {
        if (requestParameters['playerId'] == null) {
            throw new runtime.RequiredError(
                'playerId',
                'Required parameter "playerId" was null or undefined when calling getPlayerTrainingNotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['publicOnly'] != null) {
            queryParameters['publicOnly'] = requestParameters['publicOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/players/{playerId}/training-notes`;
        urlPath = urlPath.replace(`{${"playerId"}}`, encodeURIComponent(String(requestParameters['playerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingNoteFromJSON));
    }

    /**
     * Get training notes for a player
     */
    async getPlayerTrainingNotes(requestParameters: GetPlayerTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingNote>> {
        const response = await this.getPlayerTrainingNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get recurring payment records for a training
     */
    async getRecurringTrainingPaymentsRaw(requestParameters: GetRecurringTrainingPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingRecurringPayment>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRecurringTrainingPayments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/recurring-payments`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingRecurringPaymentFromJSON));
    }

    /**
     * Get recurring payment records for a training
     */
    async getRecurringTrainingPayments(requestParameters: GetRecurringTrainingPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingRecurringPayment>> {
        const response = await this.getRecurringTrainingPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get session attendance records
     */
    async getSessionAttendanceRaw(requestParameters: GetSessionAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingAttendance>>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getSessionAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/training-sessions/{sessionId}/attendance`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingAttendanceFromJSON));
    }

    /**
     * Get session attendance records
     */
    async getSessionAttendance(requestParameters: GetSessionAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingAttendance>> {
        const response = await this.getSessionAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a training by id
     */
    async getTrainingByIdRaw(requestParameters: GetTrainingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Training>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTrainingById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingFromJSON(jsonValue));
    }

    /**
     * Get a training by id
     */
    async getTrainingById(requestParameters: GetTrainingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Training> {
        const response = await this.getTrainingByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get notes for a training
     */
    async getTrainingNotesRaw(requestParameters: GetTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingNote>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTrainingNotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['publicOnly'] != null) {
            queryParameters['publicOnly'] = requestParameters['publicOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/notes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingNoteFromJSON));
    }

    /**
     * Get notes for a training
     */
    async getTrainingNotes(requestParameters: GetTrainingNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingNote>> {
        const response = await this.getTrainingNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get training players
     */
    async getTrainingPlayersRaw(requestParameters: GetTrainingPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlayer>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTrainingPlayers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/players`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingPlayerFromJSON));
    }

    /**
     * Get training players
     */
    async getTrainingPlayers(requestParameters: GetTrainingPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlayer>> {
        const response = await this.getTrainingPlayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get sessions for a training
     */
    async getTrainingSessionsRaw(requestParameters: GetTrainingSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingSession>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTrainingSessions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/sessions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingSessionFromJSON));
    }

    /**
     * Get sessions for a training
     */
    async getTrainingSessions(requestParameters: GetTrainingSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingSession>> {
        const response = await this.getTrainingSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all trainings created by a user
     */
    async getUserTrainingsRaw(requestParameters: GetUserTrainingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Training>>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getUserTrainings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{email}/trainings`;
        urlPath = urlPath.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingFromJSON));
    }

    /**
     * Get all trainings created by a user
     */
    async getUserTrainings(requestParameters: GetUserTrainingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Training>> {
        const response = await this.getUserTrainingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark attendance for a player in a session
     */
    async markAttendanceRaw(requestParameters: MarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingAttendance>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling markAttendance().'
            );
        }

        if (requestParameters['attendanceMarkRequest'] == null) {
            throw new runtime.RequiredError(
                'attendanceMarkRequest',
                'Required parameter "attendanceMarkRequest" was null or undefined when calling markAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/training-sessions/{sessionId}/attendance`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttendanceMarkRequestToJSON(requestParameters['attendanceMarkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingAttendanceFromJSON(jsonValue));
    }

    /**
     * Mark attendance for a player in a session
     */
    async markAttendance(requestParameters: MarkAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingAttendance> {
        const response = await this.markAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a player from a training
     */
    async removePlayerFromTrainingRaw(requestParameters: RemovePlayerFromTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removePlayerFromTraining().'
            );
        }

        if (requestParameters['playerId'] == null) {
            throw new runtime.RequiredError(
                'playerId',
                'Required parameter "playerId" was null or undefined when calling removePlayerFromTraining().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/trainings/{id}/players/{playerId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"playerId"}}`, encodeURIComponent(String(requestParameters['playerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a player from a training
     */
    async removePlayerFromTraining(requestParameters: RemovePlayerFromTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePlayerFromTrainingRaw(requestParameters, initOverrides);
    }

    /**
     * Update a training
     */
    async updateTrainingRaw(requestParameters: UpdateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Training>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTraining().'
            );
        }

        if (requestParameters['trainingUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingUpdateRequest',
                'Required parameter "trainingUpdateRequest" was null or undefined when calling updateTraining().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingUpdateRequestToJSON(requestParameters['trainingUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingFromJSON(jsonValue));
    }

    /**
     * Update a training
     */
    async updateTraining(requestParameters: UpdateTrainingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Training> {
        const response = await this.updateTrainingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a training note
     */
    async updateTrainingNoteRaw(requestParameters: UpdateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingNote>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTrainingNote().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updateTrainingNote().'
            );
        }

        if (requestParameters['trainingNoteCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingNoteCreateRequest',
                'Required parameter "trainingNoteCreateRequest" was null or undefined when calling updateTrainingNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/notes/{noteId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingNoteCreateRequestToJSON(requestParameters['trainingNoteCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingNoteFromJSON(jsonValue));
    }

    /**
     * Update a training note
     */
    async updateTrainingNote(requestParameters: UpdateTrainingNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingNote> {
        const response = await this.updateTrainingNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update training-specific player fee and invitation settings
     */
    async updateTrainingPlayerSettingsRaw(requestParameters: UpdateTrainingPlayerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingPlayer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTrainingPlayerSettings().'
            );
        }

        if (requestParameters['playerId'] == null) {
            throw new runtime.RequiredError(
                'playerId',
                'Required parameter "playerId" was null or undefined when calling updateTrainingPlayerSettings().'
            );
        }

        if (requestParameters['trainingPlayerSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingPlayerSettingsRequest',
                'Required parameter "trainingPlayerSettingsRequest" was null or undefined when calling updateTrainingPlayerSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/players/{playerId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"playerId"}}`, encodeURIComponent(String(requestParameters['playerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingPlayerSettingsRequestToJSON(requestParameters['trainingPlayerSettingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingPlayerFromJSON(jsonValue));
    }

    /**
     * Update training-specific player fee and invitation settings
     */
    async updateTrainingPlayerSettings(requestParameters: UpdateTrainingPlayerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingPlayer> {
        const response = await this.updateTrainingPlayerSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a training session
     */
    async updateTrainingSessionRaw(requestParameters: UpdateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingSession>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTrainingSession().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling updateTrainingSession().'
            );
        }

        if (requestParameters['trainingSessionUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingSessionUpdateRequest',
                'Required parameter "trainingSessionUpdateRequest" was null or undefined when calling updateTrainingSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/sessions/{sessionId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingSessionUpdateRequestToJSON(requestParameters['trainingSessionUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingSessionFromJSON(jsonValue));
    }

    /**
     * Update a training session
     */
    async updateTrainingSession(requestParameters: UpdateTrainingSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingSession> {
        const response = await this.updateTrainingSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or update a recurring payment record for a training player and billing period
     */
    async upsertRecurringTrainingPaymentRaw(requestParameters: UpsertRecurringTrainingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingRecurringPayment>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling upsertRecurringTrainingPayment().'
            );
        }

        if (requestParameters['trainingRecurringPaymentUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'trainingRecurringPaymentUpsertRequest',
                'Required parameter "trainingRecurringPaymentUpsertRequest" was null or undefined when calling upsertRecurringTrainingPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/trainings/{id}/recurring-payments`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingRecurringPaymentUpsertRequestToJSON(requestParameters['trainingRecurringPaymentUpsertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingRecurringPaymentFromJSON(jsonValue));
    }

    /**
     * Create or update a recurring payment record for a training player and billing period
     */
    async upsertRecurringTrainingPayment(requestParameters: UpsertRecurringTrainingPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingRecurringPayment> {
        const response = await this.upsertRecurringTrainingPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
